import {
    CtmTranslateService,

    convertBoolean,
    convertNumber,
    textFormat
} from "../../_common";
import {
    AutocompleteData,
    AutoCompleteServer
} from "../../_common/models/autocomplete";

export const AUTOCOMPLETE_CACHE = {
    "GROUP": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Common/GetUserGroupAutoComplete",
            alwayLoad: true
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "GroupID"
    }),
    "USER": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Common/GetUserAutoComplete"
        }),
        display: "UserName",
        value: "UserName"
    }),
    "ACTIVE_STATUS": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Common/GetConstantAutoComplete",
            data: {
                ConstantCode: "ACTIVE_STATUS"
            }
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "ConstantValue",
        compareValue: (val1, val2) => {
            return convertBoolean(val1) == convertBoolean(val2);
        },
        returnValue: (val) => {
            return convertBoolean(val);
        }
    }),
    "DISPLAY_PAGE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Common/GetConstantAutoComplete",
            data: {
                ConstantCode: "DISPLAY_PAGE"
            }
        }),
        display: "NameEN",
        value: "ConstantValue",
        compareValue: (val1, val2) => {
            return convertNumber(val1) == convertNumber(val2);
        },
        returnValue: (val) => {
            return convertNumber(val);
        }
    }),
    "USER_PASSWORD_AGES": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Common/GetConstantAutoComplete",
            data: {
                ConstantCode: "USER_PASSWORD_AGES"
            }
        }),
        display: "NameEN",
        value: "ConstantValue",
        compareValue: (val1, val2) => {
            return convertNumber(val1) == convertNumber(val2);
        },
        returnValue: (val) => {
            return convertNumber(val);
        }
    }),
    "CHECKER_LEVEL": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Common/GetConstantAutoComplete",
            data: {
                ConstantCode: "CHECKER_LEVEL"
            }
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "ConstantValue",
        compareValue: (val1, val2) => {
            return convertNumber(val1) == convertNumber(val2);
        },
        returnValue: (val) => {
            return convertNumber(val);
        }
    }),
    "THEATRE_SUB": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetTheatreSubAutoComplete"
        }),
        display: "Name",
        value: "TheatreSubID",
        compareValue: (val1, val2) => {
            return convertNumber(val1) == convertNumber(val2);
        },
        returnValue: (val) => {
            return convertNumber(val);
        }
    }),
    "SYSTEM_TYPE_BY_THEATRE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetSystemTypeByTheatreAutoComplete"
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "SystemTypeID",
        compareValue: (val1, val2) => {
            return convertNumber(val1) == convertNumber(val2);
        },
        returnValue: (val) => {
            return convertNumber(val);
        }
    }),
    "MOVIE_TYPE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetMovieTypeAutoComplete"
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "MovieTypeID"
    }),
    "MOVIE_STATUS": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetMovieStatusAutoComplete"
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "StatusID"
    }),
    "MOVIE_DITRIBUTOR": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetMovieDistributorAutoComplete"
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "DistributorID"
    }),
    "MOVIE_GENRE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetMovieGenreAutoComplete"
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "GenreID"
    }),
    "MOVIE_NATIONALITY": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetMovieNationalityAutoComplete"
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "NationalityID"
    }),
    "MOVIE_PATTERN": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetMoviePatternAutoComplete"
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "PatternID"
    }),
    "MOVIE_STUDIO": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetMovieStudioAutoComplete"
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "StudioID"
    }),
    "MOVIE_APPEAR_STATUS": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetMovieAppearStatusAutoComplete"
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "AppearStatusID"
    }),
    "RPT012_GROUP_BY": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Common/GetConstantAutoComplete",
            data: {
                ConstantCode: "RPT012_GROUP_BY"
            }
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "ConstantValue"
    }),
    "RPT014_TYPE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Common/GetConstantAutoComplete",
            data: {
                ConstantCode: "RPT014_TYPE"
            }
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "ConstantValue"
    }),
    "RPT016_TYPE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Common/GetConstantAutoComplete",
            data: {
                ConstantCode: "RPT016_TYPE"
            }
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "ConstantValue"
    }),
    "RPT070_TYPE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Common/GetConstantAutoComplete",
            data: {
                ConstantCode: "RPT070_TYPE"
            }
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "ConstantValue"
    }),
    "RPT080_TYPE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Common/GetConstantAutoComplete",
            data: {
                ConstantCode: "RPT080_TYPE"
            }
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "ConstantValue"
    }),
    "RPT090_TYPE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Common/GetConstantAutoComplete",
            data: {
                ConstantCode: "RPT090_TYPE"
            }
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "ConstantValue"
    }),
    "RPT130_TYPE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Common/GetConstantAutoComplete",
            data: {
                ConstantCode: "RPT130_TYPE"
            }
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "ConstantValue"
    }),
    "CIRCUIT": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetCircuitAutoComplete"
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "CircuitID"
    }),
    "THEATRE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetTheatreAutoComplete"
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "TheatreID"
    }),
    "FREE_TICKETCAP_TYPE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetFreeTicketCapTypeAutoComplete",
            alwayLoad: true
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "FreeTicketCapTypeID"
    }),
    "TICKET_TYPE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetTicketTypeAutoComplete",
            alwayLoad: true
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "TicketTypeID"
    }),
    "THEATRE_GROUP_TYPE_1": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetTheatreGroupType1AutoComplete",
            data: {
                Level: null
            }
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "GroupTypeID"
    }),
    "THEATRE_GROUP_TYPE_2": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetTheatreGroupType2AutoComplete",
            data: {
                Level: null
            }
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "GroupTypeID"
    }),
    "THEATRE_GROUP_TYPE_3": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetTheatreGroupType3AutoComplete",
            data: {
                Level: null
            }
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "GroupTypeID"
    }),
    "THEATRE_ACCOUNTING_CIRCUIT": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetTheatreAccountingCircuitAutoComplete"
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "AccountingCircuitID"
    }),
    "STUDIO_TYPE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Common/GetConstantAutoComplete",
            data: {
                ConstantCode: "STUDIO_TYPE"
            }
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "ConstantValue",
        compareValue: (val1, val2) => {
            return convertNumber(val1) == convertNumber(val2);
        },
        returnValue: (val) => {
            return convertNumber(val);
        }
    }),
    "THEATRE_TYPE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetTheatreTypeAutoComplete"
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "SystemTypeID"
    }),
    "FILM_TYPE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetFilmTypeAutoComplete"
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "FilmTypeID"
    }),
    "SOUND_TYPE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetSoundTypeAutoComplete"
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "SoundTypeID"
    }),
    "HOLIDAY_MONTH": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Common/GetConstantAutoComplete",
            data: {
                ConstantCode: "HOLIDAY_MONTH"
            }
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "ConstantValue",
        compareValue: (val1, val2) => {
            return convertNumber(val1) == convertNumber(val2);
        },
        returnValue: (val) => {
            return convertNumber(val);
        }
    }),
    "RPT160_TYPE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Common/GetConstantAutoComplete",
            data: {
                ConstantCode: "RPT160_TYPE"
            }
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "ConstantValue"
    }),
    "GROUP_BOOKING": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Common/GetConstantAutoComplete",
            data: {
                ConstantCode: "GROUP_BOOKING"
            }
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "ConstantValue"
    }),
    "SYSTEM_TYPE_SPARTA": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetSystemTypeSPARTAAutoComplete"
        }),
        display: (translate: CtmTranslateService, data) => {
            return data["Name"];
        },
        value: "SystemTypeID",
        compareValue: (val1, val2) => {
            return convertNumber(val1) == convertNumber(val2);
        },
        returnValue: (val) => {
            return convertNumber(val);
        }
    }),
    "PROVINCE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetProvinceAutoComplete"
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "ProvinceID"
    }),
    "GROUP_TYPE": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Master/GetGroupTypeAutoComplete",
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "GroupType"
    }),
    "GROUP_TYPE_LEVEL": new AutocompleteData({
        server: new AutoCompleteServer({
            url: "api/Common/GetConstantAutoComplete",
            data: {
                ConstantCode: "GROUP_TYPE_LEVEL"
            }
        }),
        display: (translate: CtmTranslateService, data) => {
            if (translate.isLanguageEN == true) {
                return data["NameEN"];
            }

            return data["NameLC"];
        },
        value: "ConstantValue",
        compareValue: (val1, val2) => {
            return convertNumber(val1) == convertNumber(val2);
        },
        returnValue: (val) => {
            return convertNumber(val);
        }
    }),
};


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_custom/models/autocomplete.ts